import { render, staticRenderFns } from "./IntegrationsVacancyList.vue?vue&type=template&id=340d2355&scoped=true&"
import script from "./IntegrationsVacancyList.vue?vue&type=script&lang=js&"
export * from "./IntegrationsVacancyList.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsVacancyList.vue?vue&type=style&index=0&id=340d2355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340d2355",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsVacancyList.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsVacancyList.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCheckbox,VIcon})
